export function hasValue<TType>(value: TType): value is Exclude<TType, null | undefined> {
  return value !== null && value !== undefined;
}

export function isObject(value: unknown): value is { [key: string]: unknown } {
  return value instanceof Object;
}

export function keysOf<T>(obj: T): (keyof T)[] {
  return Object.keys(obj as object) as (keyof T)[];
}

export function times(n: number, type: StringConstructor | NumberConstructor = String) {
  return Array.from({ length: n }, (_, i) => type(i));
}

export function isNumber(val: unknown): val is number {
  return typeof val === "number";
}
